import type { Examinationsmoment } from '../types'

/** Rubriker för de fältnamn vi känner igen. Okända fält rubriceras på sitt eget
 *  namn — hellre en trubbig rubrik än en utelämnad kolumn. */
const KOLUMN_ETIKETT: Record<string, string> = {
  moment: 'Moment',
  namn: 'Moment',
  titel: 'Moment',
  beskrivning: 'Beskrivning',
  innehall: 'Innehåll',
  form: 'Form',
  bedomning: 'Bedömning',
  bedomningsform: 'Bedömningsform',
  underlag: 'Underlag',
  larandemal: 'Lärandemål',
  betygsnivaer: 'Betygsnivåer',
  nar: 'När',
  lektion: 'Lektion',
  lektioner: 'Lektioner',
}

const rubrik = (kolumn: string) =>
  KOLUMN_ETIKETT[kolumn] ?? kolumn.replace(/_/g, ' ').replace(/^./, (t) => t.toUpperCase())

/** Examinationens moment som tabell. Kolumnerna läses ur datat i författarens
 *  ordning i stället för att hårdkodas — schemat beskriver moment[] som en
 *  tabell utan att låsa vilka fält den har, och en hårdkodad kolumnlista skulle
 *  tyst tappa allt som inte fanns med när den skrevs. */
export default function ExaminationsTabell({ moment }: { moment: Examinationsmoment[] }) {
  if (moment.length === 0) return null

  const kolumner: string[] = []
  for (const rad of moment) {
    for (const kolumn of Object.keys(rad)) {
      if (!kolumner.includes(kolumn)) kolumner.push(kolumn)
    }
  }

  return (
    <div className="dokument dokument-inbaddad">
      <table>
        <thead>
          <tr>
            {kolumner.map((kolumn) => (
              <th key={kolumn} scope="col">
                {rubrik(kolumn)}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {moment.map((rad, i) => (
            <tr key={i}>
              {kolumner.map((kolumn) => (
                <td key={kolumn}>{rad[kolumn] ?? ''}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
